import React from 'react'
import { Link } from 'react-router-dom'
import Room from 'material-ui/svg-icons/action/group-work'
import Contacts from 'material-ui/svg-icons/communication/contacts'
import Settings from 'material-ui/svg-icons/action/settings'
import Recordings from 'material-ui/svg-icons/av/video-library'
import Notification from 'material-ui/svg-icons/social/notifications'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import { FormattedMessage } from 'react-intl'
import NewSeminarButton from './NewSeminarButton'
import { guestMenuItemStyles, menuItemStyles } from './styles'
import { checkAdminUrl } from '../../lib'
import { Helmet } from 'react-helmet'

(function () {
  var link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = window.location.origin + '/img/faviconWebinar.ico'
  // link.href =  '/img/faviconFVlite.ico'
  document.getElementsByTagName('head')[0].appendChild(link)
})()

const Navigation = (props) => (
  <div className='h-100 flex flex-column justify-between'>
    <Helmet>
      <title>{'FreshVoice Webinar'}</title>
    </Helmet>
    <div>
      {(checkAdminUrl(props.path)) ? (
        <div className='mb3'>
          <NewSeminarButton
            newSeminar
            open={props.open}
            newSeminarUpgradeModal={props.newSeminarUpgradeModal}
            createConference={props.createConference}/>
        </div>
      ) : ''}
      <div>
        <Menu
          disableAutoFocus
          selectedMenuItemStyle={{
            backgroundColor: (!checkAdminUrl(props.path)) ? 'rgba(231, 235, 240, 0.2)' : '#e7ebf0',
            color: (!checkAdminUrl(props.path)) ? '#FFFFFF' : '#6B7C93'
          }}
          value={props.path}
          autoWidth={false}
          width='100%'
          listStyle={{width: '0.01%'}}
          style={{width: '100%'}}>
          <MenuItem
            value={(!checkAdminUrl(props.path)) ? ('/') : ('/admin')}
            primaryText={(!checkAdminUrl(props.path)) ? (
              <FormattedMessage id='loggedInNavigation.seminars'/>
            ) : (<FormattedMessage id='loggedInNavigation.rooms'/>)}
            containerElement={(!checkAdminUrl(props.path)) ? (
              <Link to={'/'}/>
            ) : (
              <Link to={'/admin'}/>
            )}
            leftIcon={<Room color={(!checkAdminUrl(props.path)) ? '#FFFFFF' : '#6B7C93'}/>}
            style={(!checkAdminUrl(props.path)) ? guestMenuItemStyles : menuItemStyles}/>
          {checkAdminUrl(props.path) ? (
            <MenuItem
              value={'/admin/contacts'}
              primaryText={<FormattedMessage id='loggedInNavigation.contacts'/>}
              containerElement={<Link to={'/admin/contacts'}/>}
              leftIcon={<Contacts color='#6B7C93'/>}
              style={menuItemStyles}/>
          ) : ''}
          {(checkAdminUrl(props.path)) ? (
            <MenuItem
              value={'/admin/news'}
              primaryText={<FormattedMessage id='loggedInNavigation.news'/>}
              containerElement={<Link to={'/admin/news'}/>}
              leftIcon={<Notification color='#6B7C93'/>}
              style={menuItemStyles}/>
          ) : ''}
          <MenuItem
            value={(!checkAdminUrl(props.path)) ? ('/settings') : ('/admin/settings')}
            primaryText={<FormattedMessage id='loggedInNavigation.settings'/>}
            containerElement={(!checkAdminUrl(props.path)) ? (
              <Link to={'/settings'}/>
            ) : (
              <Link to={'/admin/settings'}/>
            )}
            leftIcon={<Settings color={(!checkAdminUrl(props.path)) ? '#FFFFFF' : '#6B7C93'}/>}
            style={(!checkAdminUrl(props.path)) ? guestMenuItemStyles : menuItemStyles}
          />
          {false && <MenuItem
            value={(!checkAdminUrl(props.path)) ? ('/settings') : ('/admin/settings')}
            primaryText={<FormattedMessage id='loggedInNavigation.recordings'/>}
            containerElement={<Link to={'https://www.google.com'} target="_blank"/>}
            leftIcon={<Recordings color={(!checkAdminUrl(props.path)) ? '#FFFFFF' : '#6B7C93'}/>}
            style={(!checkAdminUrl(props.path)) ? guestMenuItemStyles : menuItemStyles}
          />}
        </Menu>
      </div>
    </div>
    <div>
      {(!checkAdminUrl(props.path) && ((props.accountType === 'free_guest') || props.accountType === 'free' || props.accountType === 'guest')) ? (
        <div>
          <div
            style={{fontSize: 12, color: '#FFFFFF', opacity: 0.54}}
            className='pl2 pr2 tc mb3'>
            <FormattedMessage id='loggedInNavigation.adminster'/>
          </div>
        </div>
      ) : ''}
    </div>
  </div>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/Navigation.js